import client from 'cloud-config-client';
import pupa from 'pupa';

let properties = {};

const DEFAULT_URL = `${getUrl()}config`;
const DEFAULT_PROFILE = "default";
const DEFAULT_LABEL = "master";


function getUrl() {
    let url =  window.location.href.endsWith('/') ? window.location.href.substring(0, window.location.href.length-1) : window.location.href
    if (url.includes('/#')){
        url = window.location.href.substring(0,url.indexOf('/#'));
    }
    return url.endsWith('/') ? url : url.concat('/');
}

function getContextFromUrl() {
    let url = getUrl();
    let url_origin = window.location.origin;
    url = url.substring(url_origin.length, url.length)
    return url.endsWith('/') ? url : url.concat('/');
}

/**
 * Inicia el entorno y carga las propiedades
 */
const initEnvironment = async () => {
    await getConfigDetails();
    await getRemoteProperties();
    //envToProperties();
    expandValues();
    log(properties);
}

/**
 * Obtiene la URL, profile y label del config, preguntando al back-end
 */
const getConfigDetails = async () => {
    let profile = DEFAULT_PROFILE;
    let label = DEFAULT_LABEL;
    let urlConfig = `${getContextFromUrl()}`+ "config-details";
    const response = await fetch(urlConfig);
    if (response.status === 200) {
        const responseBody = await response.body.getReader().read();
        const configString = new TextDecoder("utf-8").decode(responseBody.value);
        const config = JSON.parse(configString);
        profile = config.profile;
        label = config.label;
    }

    properties.REACT_APP_CONFIG_PROFILE = process.env.REACT_APP_CONFIG_PROFILE || profile;
    properties.REACT_APP_CONFIG_LABEL = process.env.REACT_APP_CONFIG_LABEL || label;
    properties.REACT_APP_CONFIG_URL = process.env.REACT_APP_CONFIG_URL || DEFAULT_URL;
}

/**
 * Obtiene una clave (xx.xx...) y la devuelve en forma de env (XX_XX...)
 * @param {String} key 
 */
const formatKey = (key) => (
	key.toUpperCase().replace(/\./g, '_')
);

/**
 * Formatea un valor cambiando las referencias a otras claves en la forma properties a la forma env
 * para que tanto properties como envs se puedan completar mutuamente después.
 */
const formatValue = (valueInput) => {
    let value = valueInput;
    let oldKeyFrom = value.indexOf("${");
    let oldKeyTo = value.indexOf("}", oldKeyFrom);

    while(oldKeyFrom !== -1 && oldKeyTo !== -1) {
        let oldKey = value.substring(oldKeyFrom, oldKeyTo + 1);
        let newKey = formatKey(oldKey.substring(1, oldKey.length));
        value = value.replace(oldKey, newKey);
        
        oldKeyFrom = value.indexOf("${", oldKeyTo);
        oldKeyTo = value.indexOf("}", oldKeyFrom);
    }
    return value;
}

/**
 * Obtiene las propiedades preguntando en spring cloud config según el entorno
 */
const getRemoteProperties = async () => {
    try {
        const config = await client.load({
            application: "ov3-frontend-application",
            endpoint: properties.REACT_APP_CONFIG_URL,
            profiles: properties.REACT_APP_CONFIG_PROFILE,
            label: properties.REACT_APP_CONFIG_LABEL
        });
        config.forEach(p => {
            const value = config.get(p);
            const newKey = formatKey(p);
            properties[newKey] = formatValue(value);
        });
    }
    catch(err) {
    }
}

/**
 * Coge las variables de entorno y las vuelca con el resto de propiedades
 */
const envToProperties = () => {
    for (var prop in process.env) {
        if (Object.prototype.hasOwnProperty.call(process.env, prop)) {
            const value = process.env[prop];
            if (value != null && value.trim().length > 0) {
                properties[prop] = process.env[prop];
            }
        }
    }
}

/**
 * Reemplaza las referencias en los valores por valores disponibles
 * comparten contexto propiedades y envs
 */
const expandValues = () => {
    const templateRegexp = /{[\w-]+}/g;
    for (var prop in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, prop)) {
            let value = properties[prop];
            if (value.search(templateRegexp) !== -1) {
                properties[prop] = pupa(value, properties);

                /*
                A veces podemos estar reemplazando una referencia por un valor que aun conserva otra referencia, 
                con una segunda pasada estamos mas seguros de que esto no pasa, pero en un futuro si hay muchas referencias 
                anidadas habría que plantear una solución más compleja para evitar que se queden algunas sin resolver.
                */
                if (properties[prop].search(templateRegexp) !== -1) {
                    properties[prop] = pupa(properties[prop], properties)
                }
            // Convierto los valores boolean en string a valores boolean reales
            } else if (value === "true" || value === "false") {
                properties[prop] = value === "true" ? true : false;
            }
        }
    }
}


/**
 * Utilidad para crear trazas en la consola, sólo si estás en modo debug
 * @param {*} content, el contenido a mostrar en la consola
 */
const log = (content) => {
}


export { properties, initEnvironment, getUrl, getContextFromUrl };
